<template>
  <section class="style-section">
    <div class="title-guide">什么是Helper for Midas？</div>
    <div class="content-guide">
      Helper for Midas是一款桥梁结构快速建模软件， 它基于Midas
      Civil所支持的mct文件格式， 按桥梁设计人员习惯简化参数输入，
      帮助你高效的进行桥梁结构建模。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">为什么要用Helper for Midas？</div>
    <div class="content-guide">
      Midas
      Civil是一款常用桥梁结构通用有限元计算程序，虽然程序也内置了桥梁建模助手，
      但是由于需要考虑到软件通用性，参数输入复杂且与桥梁设计人员的习惯有一定出入。
      为了解决这样的问题，我们开发了Helper for
      Midas。有了它，就能有效的提高你的桥梁建模效率。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">Helper for Midas能做什么？</div>
    <div class="content-guide">
      使用本软件可以一键生成Midas Civil支持的mct文件， 再通过Midas
      Civil的导入功能可以迅速得到常规桥梁结构的模型。
      目前支持的桥梁结构有：装配式结构、现浇箱梁、悬浇箱梁。      
    </div>
    <li class="content-guide" style="font-weight: 600;">本软件支持的Midas Civil最低版本为2017版（对应版本号8.3.2），该版本之后的所有版本均支持。</li>
    <div class="img-guide">
      <div class="title-img">装配式结构桥梁整体模型</div>
      <div class="title-img">
        <el-image class="size-img" :src="url1" :fit="fit" />
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">现浇箱梁结构桥梁模型</div>
      <div class="title-img">
        <el-image class="size-img" :src="url2" :fit="fit" />
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">悬浇箱梁结构桥梁模型</div>
      <div class="title-img">
        <el-image class="size-img" :src="url3" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">适应多种桥梁结构</div>
    <div class="content-guide">
      <div>        程序提供了多个模块，对应各种不同的结构类型。      </div>
      <div>        装配式结构单梁模块——用于建立采用横向分布系数法计算的装配式（空心板、T梁、小箱梁）单梁模型。      </div>
      <div>        装配式结构梁格模块——用于建立采用空间梁格法计算的装配式（空心板、T梁、小箱梁）空间梁格模型。      </div>
      <div>        装配式结构桥墩模块——用于建立包含上部、下部构造的装配式结构全桥模型，支持多联结构。      </div>
      <div>        等高现浇箱梁模块——用于建立等高现浇箱梁模型，支持单梁、折面梁格、空间网格模型。      </div>
      <div>        变高现浇箱梁模块——用于建立变高现浇箱梁模型，支持单梁、折面梁格模型。      </div>
      <div>        悬浇变高箱梁模块——用于建立悬浇连续梁、连续刚构的全桥模型，模型包含悬浇施工过程。      </div>
      <div>        等高裤衩箱梁模块——用于建立等高裤衩箱梁的折面梁格模型，也可用于建立斜交箱梁的折面梁格模型。      </div>
      <div>        各个模块具体功能详见模块详细说明。      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">简单参数</div>
    <div class="content-guide">
      装配式结构可以直接引用后台服务器上的数据库，
      仅需定义孔跨、桥面布置以及梁片数、中距参数。
      常用结构参数输入需求少，与桥梁设计师习惯一致。
    </div>
    <div class="img-guide">
      <el-image
          class="size-img"
          style="height: 400px"
          :src="url4"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList4"
          :initial-index="0"
          fit="cover"/>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">自动匹配参数</div>
    <div class="content-guide">
      箱梁结构可仅仅根据提供的孔跨、桥面布置、结构类型等少量参数，
      自动匹配合适的结构尺寸、钢束形状数量等参数，方便计算后调整参数。
    </div>
    <div class="img-guide">
      <div class="demo-image__preview">
        <el-image
          class="size-img"
          style="height: 400px"
          :src="url5"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList5"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">生成模型参数完整</div>
    <div class="content-guide">
      使用Midas
      Civil导入生成的mct文件后，可以看到程序生成的模型包含分析控制数据、
      结构、特性值、边界条件、静力荷载、张拉钢束、移动荷载分析、施工阶段等完整的参数，
      生成的模型可以直接用于计算。
    </div>
    <div class="img-guide">
      <el-image class="size-img" style="height: 240px" :src="url6" :fit="fit" />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">按设计习惯设计参数</div>
    <div class="content-guide">
      在Midas Civil中，建模思路是按照“节点——单元——材料——边界条件——钢束——荷载”的方式逐步进行，
      这与桥梁设计师的桥梁设计图思路完全不同。程序按照设计图纸的表达方式设计参数输入，
      采用“结构类型——孔跨布置——材料选择——形状尺寸参数——钢束形状参数——荷载选择”的方式来进行参数表达，
      更加符合桥梁设计习惯，便于桥梁设计师使用。
    </div>
    <div class="img-guide">
      <div class="demo-image__preview">
        <el-image
          class="size-img"
          style="height: 400px"
          :src="url7"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList7"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/function-1.png"),
      url2: require("@/assets/png/function-2.png"),
      url3: require("@/assets/png/function-3.png"),
      url4: require("@/assets/png/function-4.png"),
      url5: require("@/assets/png/function-5.png"),
      url6: require("@/assets/png/function-6.png"),
      url7: require("@/assets/png/function-7.png"),
      fit: "fill",
      srcList4: [require("@/assets/png/function-4.png")],
      srcList5: [require("@/assets/png/function-5.png")],
      srcList7: [require("@/assets/png/function-7.png")],
    };
  },
};
</script>

<style>
.style-section {
  padding: 25px;
}
.title-guide {
  font-size: 22px;
  line-height: 2;
  font-weight: 600;
  text-align: left;
  padding-left: 10px;
  padding-bottom: 15px;
}
.content-guide {
  font-size: 16px;
  line-height: 2;
  font-weight: 500;
  text-align: left;
  padding-left: 15px;
  letter-spacing: 1px;
}
.img-guide {
  padding-top: 15px;
  padding-bottom: 15px;
  margin: auto;
  text-align: center;
}
.title-img {
  font-size: 20px;
  line-height: 2;
  font-weight: 600;
  padding: 5px;
}
.size-img {
  padding: 5px;
  width: 780px;
  height: 300px;
}
</style>
